
import { Component, Prop, Vue } from "vue-property-decorator";
import QrCode from "@common/src/components/scope/qr-code/index.vue";
import t from "@common/src/i18n/t";
@Component({
  components: { QrCode }
})
export default class CampaignQrCode extends Vue {
  @Prop({ default: () => {}, type: Object })
  qrData: any;
  @Prop({ default: true, type: Boolean })
  showH5Share: boolean;
  @Prop({ default: true, type: Boolean })
  showH5UrlCopy: boolean;
  t = t;
  storeQrUrl: string = "";
  handleDownloadQR(type) {
    const a = document.createElement("a");
    a.download = "QR" + new Date().getTime() || t("v210801.download-picture-name");
    a.href = type === "mini-app" ? this.qrData.miniQRCodeUrl : (this.$refs["wxQrCode"] as any).getQrBase64();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  tipCopy() {
    this.$message.success(t("v210831.copy-succeeded"));
  }
}
